import { token } from '@/infrastructure/container';

export interface IFileOutput {
  download(filename: string, contents: string, mime?: string): void;
}

export const TOKEN_IFileOutput = token<IFileOutput>('IFileOutput');

export class FileOutput implements IFileOutput {
  download(filename: string, contents: string, mime: string = 'text/csv'): void {
    const blob = new Blob([contents], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
}

export class InMemoryFileOutput implements IFileOutput {
  downloads: { filename: string; contents: string; mime: string }[] = [];
  download(filename: string, contents: string, mime: string = 'text/csv'): void {
    this.downloads.push({ filename, contents, mime });
  }
}
